import React from "react"
import { useForm, FormProvider, useFormContext } from 'react-hook-form'
import _ from "lodash"
import { DragDropContext } from "@hello-pangea/dnd"
//************************************//
import { uuidv4 } from '@utils'
import { isNullOrUndefined } from "@syncfusion/ej2-base"
//************************************//

const CustomFieldsProvider = props => {
  //************************************//
  const { children, customFieldsState = {} } = props
  //************************************//
  const { customFields, setCustomFields } = customFieldsState
  //************************************//
  const formMethods = useForm()
  //************************************//
  // ADR reference: ./README.md#how-the-global-component-works
  // ADR decision link: ./README.md#adr--decisions
  const onDragEnd = (result) => {
    if (customFields) {
      // Move from unused list into active grouped fields.
      if (result?.source?.droppableId === "custom-fields-details" && result?.destination && result?.destination?.droppableId !== "custom-fields-details") {
        const sourceList = _.cloneDeep(customFields.unusedCustomFieldsList)
        const destinationList = _.cloneDeep(_.filter(customFields.entityCustomFieldsList, x => !_.isNull(x.parent_id)))

        const [removed] = sourceList.splice(result.source.index, 1)

        destinationList.splice(result.destination.index, 0, { ...removed, parent_id: "group1", is_required: false, is_used: true })

        setCustomFields(prevState => {
          return {
            ...prevState,
            entityCustomFieldsList: [
              _.find(prevState.entityCustomFieldsList, x => _.isNull(x.parent_id)),
              ...destinationList
            ],
            unusedCustomFieldsList: sourceList
          }
        })
      }
      // Create a brand-new field from type palette and insert into active group.
      if (result?.source?.droppableId === "new-custom-fields" && result?.destination && result?.destination?.droppableId !== "new-custom-fields") {
        setCustomFields(prevState => {
          const newItem = {
            key: `new_${uuidv4()}`,
            is_used: true,
            name: ``,
            description: "",
            field_type: result.draggableId,
            is_required: false,
            default_value: {
              value: ""
            },
            config: [],
            parent_id: "group1"
          }
          const destinationList = _.cloneDeep(_.filter(prevState.entityCustomFieldsList, x => !_.isNull(x.parent_id)))
          destinationList.splice(result.destination.index, 0, newItem)
          return {
            ...prevState,
            entityCustomFieldsList: [
              _.find(prevState.entityCustomFieldsList, x => _.isNull(x.parent_id)),
              ...destinationList
            ],
            editItemModal: {
              isNew: true,
              data: newItem
            }
          }

        })
      }
      // Reorder active fields within group droppables.
      if (
        (result?.source?.droppableId !== "new-custom-fields" && result?.source?.droppableId !== "custom-fields-details") &&
        result?.destination &&
        (result?.destination?.droppableId !== "new-custom-fields" && result?.destination?.droppableId !== "custom-fields-details")
      ) {
        setCustomFields(prevState => {
          const list = _.cloneDeep(_.filter(prevState.entityCustomFieldsList, x => !_.isNull(x.parent_id)))

          const items = Array.from(list)
          const [removed] = items.splice(result.source.index, 1)
          items.splice(result.destination.index, 0, removed)

          return {
            ...prevState,
            entityCustomFieldsList: [
              _.find(prevState.entityCustomFieldsList, x => _.isNull(x.parent_id)),
              ...items
            ],
            refresh: !prevState.refresh
          }
        })
      }
    }
  }
  //************************************//
  return (
    <div className={'custom-field-wrapper'}>
      <FormProvider {...formMethods}>
        <div>
          <DragDropContext
            onDragEnd={onDragEnd}
          >
            {children}
          </DragDropContext>
        </div>
      </FormProvider>
    </div>
  )
}

CustomFieldsProvider.propTypes = {

}

export default CustomFieldsProvider